export const FACHOBJEKTSTATUS_GEPLANT = "GEPLANT";
export const FACHOBJEKTSTATUS_IN_BETRIEB = "IN_BETRIEB";
export const FACHOBJEKTSTATUS_STILLGELEGT = "STILLGELEGT";

/**
 * Function zum Überprüfen, ob ein Status final ist.
 * @param status
 * @returns {boolean}
 */
export function isFinalStatus(status) {
    return status === "STILLGELEGT" || status === "ANGESCHLOSSEN_AN";
}
